import axios from 'axios';
import {
  GIVING_LOGIN_STATES,
  VERIFY_PERSONAL_ID_PATH,
  mapVerifyPersonalIdError,
  normalizeLoginState,
  verifyPersonalIdPayload,
} from '@/utils/giving-login';

/**
 * The one-time personal-id check (giving per login, @/utils/giving-login):
 * `POST {baseUrl}/giving/login/verify-personal-id` on a hogc-one-api.
 *
 * MyGiving asks the PIN API (givingPinApiUrl, the one giving-api consults); My QR asks
 * the main API (VUE_APP_API_URL, the one that serves the profile). Same body, same
 * answers, same error mapping.
 *
 * Resolves `{ ok, state, isPrimaryLogin }` when the API answered, or
 * `{ ok: false, error }` with the mapped error (see mapVerifyPersonalIdError). Never
 * rejects, and never logs what was typed.
 */
export async function verifyPersonalIdAt({ baseUrl, token, fields, logLabel }) {
  try {
    const { data } = await axios.post(
      `${baseUrl}${VERIFY_PERSONAL_ID_PATH}`,
      verifyPersonalIdPayload(fields),
      { headers: { Authorization: `Bearer ${token}` } },
    );
    const loginState = normalizeLoginState(data) ?? {
      state: GIVING_LOGIN_STATES.VERIFIED,
      isPrimaryLogin: true,
    };
    return { ok: loginState.state === GIVING_LOGIN_STATES.VERIFIED, ...loginState };
  } catch (e) {
    const error = mapVerifyPersonalIdError(e);
    // The status and code only: the request body is the member's NRIC and birthday.
    console.warn(`${logLabel} personal id check failed:`, e?.response?.status, error.kind);
    return { ok: false, error };
  }
}
